import { render, staticRenderFns } from "./PContentField.vue?vue&type=template&id=8d18ff6a"
import script from "./PContentField.vue?vue&type=script&lang=js"
export * from "./PContentField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports